var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chapter",staticStyle:{"display":"none"},attrs:{"id":'chapter_' + _vm.chapter.chapterNumber}},[_c('div',{staticClass:"content flex-column justify-center",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }